/**
 * Admin Introduction page component.
 *
 * Route: `/admin/introduction`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminIntroductionPage
 */

import IntroductionManager from '@/components/admin/IntroductionManager';

export default function AdminIntroductionPage() {
  return <IntroductionManager />;
}
